<alert *ngFor="let alert of alertsService.allAlerts$ | async" [alert]="alert" (dismiss)="alertsService.dismiss($event)"></alert>
